import React from 'react'
import { Typography } from '@mui/material'
import { WithTranslation, withTranslation } from 'react-i18next'

const ForgotPasswordLinkSent = ({ t }: WithTranslation) => (
  <Typography variant='body1'>{t('forgotPw.linkSent')}</Typography>
)

export default withTranslation()(ForgotPasswordLinkSent)
